export enum StatisticsScale {
  DAY, WEEK, MONTH, YEAR, CUSTOM,CURRENT_MONTH
}
